/**
 * @generated SignedSource<<18d1cc8c4773c9f94245448a3baf6677>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appGithub_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly id: string;
    readonly githubEnabled: boolean | null;
    readonly githubInstallationId: number | null;
    readonly githubUnauthorizedInstallation: number | null;
  } | null;
  readonly " $fragmentType": "appGithub_viewer";
};
export type appGithub_viewer$key = {
  readonly " $data"?: appGithub_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"appGithub_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appGithub_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "githubEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "githubInstallationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "githubUnauthorizedInstallation",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "4b60a984904ac7c82293338561bf2837";

export default node;
